module.exports = __webpack_public_path__ + "static/media/searchClient.c5713e74.svg";